/*
 * ===============================================================================================================
 *                                Copyright 2020, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import Grid from '@mui/material/Grid';
import { Box, Button } from '@mui/material';
import Inbox from '@jda/lui-common-icon-library-mui5/ui/Inbox';
import { IEmptyComponent } from '../../models/EmptyComponent/EmptyComponent';
import useStyles from './styles';

const EmptyComponent = ({
  text = "It's empty here",
  title,
  disableCreateAction,
  handleOnCreateAction,
  primaryButtonText,
  secondaryButtonText,
  onSecondaryBtnClick,
  disableSecondaryAction
}: IEmptyComponent) => {
  const { classes } = useStyles();
  return (
    <Grid container className={classes.root}>
      <Box className={classes.innerContent} id="empty-component">
        <Inbox fontSize="large" color="action" />
        <Box id="empty-component-text" className={classes.titleAlignment}>
          {text}
        </Box>
        <Box className={classes.subtext} id="empty-component-title">{title}</Box>
        {!disableCreateAction && (
          <Button
            onClick={() => handleOnCreateAction()}
            variant="contained"
            color="primary"
            disableElevation
            className={classes.alignment}
            id="createButton"
          >
            {primaryButtonText}
          </Button>
        )}
        {secondaryButtonText && onSecondaryBtnClick && (
          <Button
            color='primary'
            size='medium'
            onClick={() => onSecondaryBtnClick()}
            className={classes.secondaryButton}
            id="secondaryButton"
            disabled={disableSecondaryAction}
          >
            {secondaryButtonText}
          </Button>
        )}
      </Box>
    </Grid>
  );
};

export default EmptyComponent;
